import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store'
import { FilterState } from './states/filter/filter.state'
import { filterReducer } from './states/filter/filter.reducers'
import { orderElementsReducer } from './data/data.reducers'
import { DataState } from './data/data.state'
import { PendingState } from '../account/account.root.state'
import { orderPendingReducer } from './states/pending/pending.reducer'
import {complaintReducer} from "./states/complaint/complaint.reducer";
import {ComplaintState} from "./states/complaint/complaint.state";

export interface OrdersState {
  filterState: FilterState
  elementsState: DataState
  pendingState: PendingState
  complaintState: ComplaintState
}

export const OrdersReducers: ActionReducerMap<OrdersState> = {
  filterState: filterReducer,
  elementsState: orderElementsReducer,
  pendingState: orderPendingReducer,
  complaintState: complaintReducer,
}

export const selectOrdersState = createFeatureSelector<OrdersState>('orders')
export const selectFilterState = createSelector(
  selectOrdersState,
  (state: OrdersState): FilterState => state.filterState,
)
export const selectElementsState = createSelector(
  selectOrdersState,
  (state: OrdersState): DataState => state.elementsState,
)

export const selectOrderPendingState = createSelector(
  selectOrdersState,
  (state: OrdersState): PendingState => state.pendingState,
)

export const selectComplaintState = createSelector(
  selectOrdersState,
  (state: OrdersState): ComplaintState => state.complaintState,
)
